import { Dispatch } from "redux";

import Firebase from "../Firebase";
import IAction from "./action";
import * as TYPES from "./types";

import * as firebase from "firebase";

export interface IEmailChanged extends IAction {
  email: string;
}

export interface IPasswordChanged extends IAction {
  password: string;
}

export interface IAuthError extends IAction {
  error: any;
}

export interface IAuthStateChanged extends IAction {
  user: firebase.User | null;
}

export const EmailChanged = (email: string): IEmailChanged => ({
  type: TYPES.EmailChanged,
  email
});

export const PasswordChanged = (password: string): IPasswordChanged => ({
  type: TYPES.PasswordChanged,
  password
});

export const StartAuth = (): IAction => ({
  type: TYPES.StartAuth
});

export const DoneAuth = (): IAction => ({
  type: TYPES.AuthDone
});

export const AuthError = (e: any): IAuthError => ({
  type: TYPES.AuthDone,
  error: e
});

export const doAuthenticate = (
  fb: Firebase,
  email: string,
  password: string
) => {
  return (dispatch: Dispatch) => {
    dispatch(StartAuth());

    fb.signIn(email, password)
      .then(() => {
        dispatch(DoneAuth());
      })
      .catch((e: any) => {
        dispatch(AuthError(e));
      });
  };
};

export const AuthStateChanged = (
  user: firebase.User | null
): IAuthStateChanged => ({
  type: TYPES.AuthStateChanged,
  user
});



// WEBPACK FOOTER //
// ./src/actions/auth.ts